import React, {useState, useEffect} from 'react';
import Lightbox from 'react-image-lightbox';

interface LightboxGalleryProps {
    event: any;
    isOpen: boolean;
    onClose: () => void;
}

const LightboxGallery: React.FC<LightboxGalleryProps> = ({event, isOpen, onClose}) => {
    const [imageIds, setImageIds] = useState<number[]>([]);
    const [imageUrl, setImageUrl] = useState<string>('');
    const [imageIndex, setImageIndex] = useState(0);

    useEffect(() => {
        if (event.data) {
            const ids: number[] = event.data.imageIds.split(',').map(Number);
            setImageIds(ids);
            setImageUrl(event.data.url);
            const index = ids.indexOf(event.data.idDokument);
            if (index !== -1) {
                setImageIndex(index);
            }
        }
    }, [event]);

    return isOpen ? (
        <div onClick={e => e.stopPropagation()} className={'image-gallery'}>
            <Lightbox
                mainSrc={`${imageUrl}${imageIds[imageIndex]}`}
                nextSrc={`${imageUrl}${imageIds[(imageIndex + 1) % imageIds.length]}`}
                prevSrc={`${imageUrl}${imageIds[(imageIndex - 1 + imageIds.length) % imageIds.length]}`}
                onCloseRequest={onClose}
                onMovePrevRequest={() => setImageIndex((imageIndex + imageIds.length - 1) % imageIds.length)}
                onMoveNextRequest={() => setImageIndex((imageIndex + 1) % imageIds.length)}
                reactModalStyle={{overlay: {zIndex: 42000}}}
            />
        </div>
    ) : null;
};

export default LightboxGallery;
